<template>
  <div id="root">
    <div class="left">
      <div class="carousel">
        <el-carousel style="height: 100%">
          <el-carousel-item>
            <img src="../../public/img/car1.jpg"/>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../public/img/car2.jpg"/>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../public/img/car3.jpg"/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="info">
        <h3>克鲁克信息报备系统声明</h3>
        <div class="body">
          1.我们建议经销商拿到客户需求信息之后第一时间登陆系统完成报备，报备的时间将作为报备考核的重要因素<br/>
          2.带 * 号为必填项，不填写无法完成提交<br/>
          3.提交以后，负责终端用户所在区域的克鲁克区域销售经理和销售总监会第一时间收到报备审核邮件，
          首先区域销售经理审核，其次销售总监审核，二者都审核通过视为项目报备成功。经销商也会很快收到系统的邮件反馈，
          告知项目报备的结果。项目报备成功后，克鲁克总部只会支持报备成功的经销商参与项目<br/>
          4.如果遇到项目重复报备，报备提交的时间很接近，克鲁克的区域销售会根据项目信息的完整性以及经销商对项目的实际把控能力做出最终判断，
          所以经销商朋友在填写报备信息的时候一定要尽量完整，如有任何疑问，请拨打销售服务热线 400 018 2122<br/>
        </div>
      </div>
    </div>


    <div class="right">
        <header><h3>登录系统</h3></header>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="loginForm">
          <el-form-item label=""  prop="userName" size="large">
            <el-input v-model="ruleForm.userName" placeholder="请输入用户名称" prefix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <el-form-item label=""  prop="pass" size="large">
            <el-input  type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入登录密码" prefix-icon="el-icon-lock" :show-password="true"></el-input>
          </el-form-item>
          <el-form-item class="codeItem" prop="checkCode" size="large">
            <el-input
                v-model.number="ruleForm.checkCode"
                autocomplete="off" maxlength="6"
                class="codeInput"
                oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="验证码"
                prefix-icon="el-icon-s-check"></el-input >
            <el-button type="primary" @click="getCode" class="codeBtn" :class="{'codeBtnClick':checkCodeLock}"><span>获取验证码{{checkCodeTime===0?'':`(${checkCodeTime})`}}</span></el-button>
          </el-form-item>
          <div class="error" v-if="!data.status">{{data.msg}}</div>
          <el-form-item >
            <el-button class="loginBtn"
                       type="primary"
                       @click="login('ruleForm')">
              <span class="button_text">登&nbsp;&nbsp;&nbsp;录</span>
            </el-button>
          </el-form-item>
          <div class="regist"><span>如果没有账号，请先<el-link :underline="false" @click.prevent="$emit('changePage');">注册账号</el-link></span></div>
        </el-form>
    </div>
  </div>
</template>

<script>

import {Loading, Message} from "element-ui";
import {mapMutations} from "vuex";

export default {
  name: "loginPanel",
  props:[],
  data() {
    return {
      images:[
          '../../public/img/car1.jpg',
          '../../public/img/car2.jpg',
          '../../public/img/car3.jpg',
      ],
      ruleForm: {
        userName: '',
        pass: '',
        checkCode:'',
      },
      rules: {
        pass: [
          { required:true ,message:'密码不能为空', trigger: 'blur' }
        ],
        userName: [
          { required:true ,message:'用户名不能为空', trigger: 'blur' }
        ],
        checkCode: [
          { required:true ,message:'请输入验证码', trigger: 'blur' }
        ]
      },
      data:{
        status:true,
        msg:''
      },
      btnClick:false,
      checkCodeLock:false,
      checkCodeTime:0
    };
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate(async (valid,object) => {
        if (valid) {
          const lockScreen = Loading.service({
            lock: true,
            text: '登录中',
            background: 'rgba(0, 0, 0 ,0.2)'
          });
          const result = await this.$api.checkCheckCode(this.ruleForm.userName,null,this.ruleForm.checkCode);
          if (result){
            const res = await this.$api.login(this.ruleForm.userName, this.ruleForm.pass);
            if (res.token) {
              localStorage.removeItem('token');
              localStorage.setItem('token', `${res['token_type']} ${res.token}`);
              localStorage.setItem('username', this.ruleForm.userName);
              this.resetForm(formName);
              this.toPage('/navigation');
            }else {//登录失败
              Message({message:res.msg,type:"error"});
            }
          }else{
            this.$set(this.ruleForm,'checkCode','');
            Message({message:'验证码输入有误！',type:"error"});
          }
          lockScreen.close();
        } else {
          console.log(object);
        }
      });
    },
    getCode() {
      this.$refs['ruleForm'].validateField(['userName'],async (error) => {
        if (error) {
          Message({message: error, type: "error"});
        } else {
          if (this.checkCodeLock) return;
          this.$api.getCheckCode(this.ruleForm.userName, null);
          this.checkCodeLock = true;
          this.checkCodeTime = 60;
          const timer = await setInterval(() => {
            this.checkCodeTime--;
            if (this.checkCodeTime <= 0) {
              clearInterval(timer);
              this.checkCodeLock = false;
            }
          }, 1000);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    ...mapMutations([//将Vuex中的方法映射在此
      'toPage'
    ]),
  },
  computed:{

  },
  watch:{

  },
}
</script>

<style scoped>
#root{
  padding: 0;
  margin: 0;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 66vh;
  width: 59vw;
  border-radius: 6px;
}
*{
  padding: 0;
}

.left{
  display: flex;
  flex-direction: column;
  /*background:#596980;*/
  background:linear-gradient(to right bottom,rgba(89, 105, 128,.76),rgba(89, 105, 128,.4));;
  height: 100%;
  width: 50%;
  border-radius: 16px 0 0 16px;
}

.right{
  position: relative;
  display: flex;
  background: linear-gradient(to right top,rgba(255,255,255,.76),rgba(255,255,255,.4));
  height: 100%;
  width: 50%;
  border-radius: 0 16px 16px 0;

}
.left h3{
  font-family: "微软雅黑 Bold", 微软雅黑, sans-serif;
  font-weight: 600;
  font-size: 17px;
  color:#fff;
  margin: 4px auto;
  line-height: 27px;
  text-align: center;
}
.left .info .body{
  color: #fff;
  height: fit-content;
  line-height: 16px;
  width: 100%;
}
.carousel{
  padding: 20px 18px 0 18px;
  width: 100%;
  flex: 1;
}
.info{
  flex: 1;
  border: 1px solid #fff;
  border-radius: 3px;
  padding: 0 8px;
  margin: 7px 18px 10px;
}
.carousel img{
  border-radius: 3px;
  background-size: cover;
  overflow: hidden;
  height: 100% !important;
  width: 100% !important;
}


/*-------------原登录面板的元素--------------------*/
span{
  font-size:14px;
  font-family: 'Arial Normal', 'Arial', sans-serif;
}
.right h3{
  font-family: "微软雅黑 Bold", 微软雅黑, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 32px;
  color:rgba(101, 121, 155,.9);
  line-height: 180px;
  text-align: center;
  margin-top: 1px;
}
header{
  width: 100%;
}
.el-input{
  color: rgb(26, 188, 156);
  display: inline-block;
  padding-top: 3px;
  width: 300px;
}
.loginBtn{
  margin-top: 5px;
  width: 300px;
  height: 4.3rem;
  backdrop-filter: blur(2px);
  background:linear-gradient(135deg,rgba(83, 105, 118,.8),rgba(41, 46, 73,.8));
  box-shadow: 0 2px 3px rgba(83, 105, 118,.4);
  border: none;
  border-radius: 12px;
}
.loginBtn:hover{
  color: rgb(105, 195, 207);
  box-shadow: 0 0 8px rgba(101, 121, 155,.9);
}
.button_text{
  font-family: 微软雅黑, sans-serif;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  color: rgb(167, 220, 227);
}
.regist{
  text-align: right;
  margin-right:-10rem;
  margin-top: 2rem;
}
.el-form-item{
  margin: 2rem 3rem 0;
}
.el-form{
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 25px;
}
.error{
  font-size: 13px;
  color: #fe1b52;
  height: fit-content;
  margin-left: 4rem ;
  margin-top: 10px;
  z-index: 999;
}
.codeItem{
  position: relative;
  display: flex;
}
.codeInput{
  width: 146px;
  position: relative;
  left: -9px;
}
.codeBtn{
  position: relative;
  font-size: 8px;
  width: 136px;
  padding: 10px 9px;
  top: 1px;
  border-radius: 12px;
  right: -11px;
  color: rgba(207, 216, 220,.95);
  background: #425d70;
  border: none;
}
.codeBtn:hover{
  box-shadow: 0 0 8px rgba(101, 121, 155,.9);
  /*background: rgba(87, 123, 140,.9);*/
}
.codeBtnClick{
  background: rgba(87, 123, 140,.9);
}
.codeBtnClick:hover{
  box-shadow: none;
  cursor: not-allowed;
}

</style>
